import {lazy} from 'react'
import {RouteObject} from 'react-router-dom'
import {AppHelmet} from '../../components/utils/AppHelmet'
import {AppLayout} from '../../components/utils/AppLayout'
import {PageSuspenseFallback} from '../../components/utils/PageSuspenseFallback'
import {AuthProtectedLayout} from '../auth/components/AuthProtectedLayout'

const RolePage = lazy(() => import('./pages/RolePage'))
const RoleEditPage = lazy(() => import('./pages/RoleEditPage'))
const RoleCreatePage = lazy(() => import('./pages/RoleCreatePage'))

export const ROLE_ROUTES: RouteObject[] = [
  {
    path: '/roles',
    element: (
      <>
        <AppHelmet title='Roles' />
        <AuthProtectedLayout adminOnly>
          <AppLayout>
            <PageSuspenseFallback>
              <RolePage />
            </PageSuspenseFallback>
          </AppLayout>
        </AuthProtectedLayout>
      </>
    ),
    children: [
      {
        path: '/roles/create',
        element: (
          <>
            <AppHelmet title='Role create' />
            <PageSuspenseFallback>
              <RoleCreatePage />
            </PageSuspenseFallback>
          </>
        ),
      },
      {
        path: '/roles/:roleCode/edit',
        element: (
          <>
            <AppHelmet title='Role create' />
            <PageSuspenseFallback>
              <RoleEditPage />
            </PageSuspenseFallback>
          </>
        ),
      },
    ],
  },
]
